import { addMemberComplaint } from "../../../Redux/Assets/AssetsActions";
import validator, { ValidationField } from "../../../Util/validator";
import { Link, useNavigate, useSearchParams } from "react-router";
import Loading from "../../../Components/Common/Loading/Loading";
import { AppDispatch, RootState } from "../../../Redux/store";
import { useDispatch, useSelector } from "react-redux";
import arrowIcon from "../../../Assets/arrowleft.png";
import styles from "./AddComplain.module.scss";
import Error404 from "../../Error404/Error404";
import { useState } from "react";

function AddComplain() {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { addMemberComplaintLoading } = useSelector(
    (state: RootState) => state.assets,
  );

  const sno = searchParams.get("sno") || "";
  const amid = searchParams.get("amid") || "";
  const typeId = searchParams.get("type") || "";

  const [comment, setComment] = useState("");
  const [errors, setErrors] = useState<{ comment: string }>({
    comment: "",
  });

  if ((!sno || !amid) && !typeId) {
    return <Error404 />;
  }

  const addComplainHandler = () => {
    const fields: ValidationField[] = [
      {
        key: "comment",
        type: "text",
        value: comment,
      },
    ];

    const { errors: fieldErrors, isValid } = validator(fields);
    setErrors({ ...errors, ...fieldErrors });

    if (isValid && !addMemberComplaintLoading) {
      const successHandler = () => {
        navigate("/help", {
          replace: true,
        });
      };

      dispatch(
        addMemberComplaint({
          typeId,
          amenityId: amid ? amid : null,
          serialNumber: sno ? sno :null,
          comments: comment,
          successHandler,
        }),
      );
    }
  };

  return (
    <div className={styles.mainContainer}>
      {addMemberComplaintLoading && <Loading />}
      <Link to="/help" replace className={styles.backButtonContainer}>
        <button className={styles.button}>
          <img src={arrowIcon} alt="arrowIcon" className={styles.arrowIcon} />
          Back to Tickets
        </button>
      </Link>
      <div className={styles.headingContainer}>
        <h1 className={styles.heading}>Add Ticket</h1>
      </div>
      <div className={styles.formContainer}>
        <div className={styles.textAreaContainer}>
          <p className={styles.label}>Comment</p>
          <textarea
            className={styles.textArea}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            rows={4}
          />
          <p className={styles.error}>{errors.comment}</p>
        </div>

        <div className={styles.buttonContainer}>
          <button className={styles.button} onClick={addComplainHandler}>
            Add Ticket
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddComplain;
